import {SET_SIDEBAR_SOLUTION } from './actionTypes'

const setSidebarSolution = (solution, allowedConnectors, uniqueIndexes) => {
    return {
        type : SET_SIDEBAR_SOLUTION,
        info : "Sidebar redux action :",
        solution : solution,
        allowedConnectors : allowedConnectors,
        uniqueIndexes : uniqueIndexes
    }
}

export default setSidebarSolution;